"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Projektbereich() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const projects = [{
    title: "Smart Home Komplettsystem – Mehrfamilienhaus Oberwallis",
    description: "Vollständige Gebäudeautomation einer Eigentumswohnung – Licht, Beschattung, Heizung, Lüftung und Visualisierung nahtlos vernetzt. Integration von PV-Anlage, Wärmepumpe und Batteriespeicher für maximalen Eigenverbrauch.",
    image: "https://s2automation.ch/wp-content/uploads/2026/04/referenz1_smart_home.jpg?v=j5zskcfe3nc"
  }, {
    title: "Heizungsmodernisierung & Energieoptimierung – Mehrfamilienhaus Oberwallis",
    description: "Heizungsumbau mit intelligenter Einbindung in das Gesamtsystem. Wärmepumpe, PV und Speicher intelligent vernetzt für optimierten Eigenverbrauch und automatische Laststeuerung.",
    image: "https://s2automation.ch/wp-content/uploads/2026/04/referenz2_heizung.jpg?v=mpombpx9obi"
  }, {
    title: "Smart Home Vollausstattung – Eigentumswohnung Oberwallis",
    description: "Komplette Ausstattung einer mehrstöckigen Eigentumswohnung mit Loxone – Beleuchtung, Beschattung und Audio auf allen Etagen. Alle Systeme zentral steuerbar via App und Wandtaster.",
    image: "https://s2automation.ch/wp-content/uploads/2026/04/referenz3_wohnung.jpg?v=bc9w9mklmm5"
  }];
  return <section id="projektbereich" ref={ref} className={cn("dark bg-background text-foreground py-20 px-4 md:px-8 lg:px-12 overflow-hidden transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-primary font-medium tracking-wider uppercase text-sm mb-3">
            Referenzen
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold tracking-tight mb-6">
            Ausgewählte Projekte
          </h3>
          <p className="text-muted-foreground text-lg leading-relaxed">
            Ein Einblick in unsere Arbeit im Bereich Gebäudeautomation und
            Steuerungstechnik. Wir realisieren massgeschneiderte Lösungen im
            ganzen Oberwallis.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {projects.map((project, i) => <div key={i} data-index={i} className="group bg-card/40 backdrop-blur-sm border border-border/20 rounded flex flex-col overflow-hidden transition-all duration-300 hover:border-primary/40">
              <div className="aspect-video overflow-hidden">
                <img src={`${project.image}`} alt={project.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <h4 className="text-xl font-bold mb-3 text-foreground group-hover:text-primary transition-colors">
                  {project.title}
                </h4>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {project.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <Link to="/ContactPage" className="inline-flex items-center justify-center px-8 py-3 text-sm font-medium text-white transition-colors bg-primary rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary">
            Projekt anfragen
            <Zap className="ml-2 w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>;
}